import { put, takeLatest } from "redux-saga/effects";
import {
  getKnowiHashEndPoint,
  getKnowiWidgetsEndPoint,
} from "../../configuration";
import axiosInstance from "../../global/axiosInterceptor";

function* fetchWidgetsData() {
  try {
    yield put({
      type: "SET_LOADING_KNOWI",
      loading: true,
    });
    const response = yield axiosInstance.post(getKnowiWidgetsEndPoint(), {
        category: "5GVASPStaging",
    });

    if (response.status == 200) {
      const widgets = response.data;
      const widgetList = widgets.filter((m) => {
        return m.secureShareUrl.length > 0 && !m.name?.includes("lvl");
      });
      sessionStorage.setItem("knowiWidgetList", JSON.stringify(widgetList));

      yield put({
        type: "FETCH_WIDGET_SUCCESS",
        widgets: widgetList,
      });
    } else if (response.status === 401) {
      localStorage.removeItem("ng2Idle.main.expiry");
    } else {
      const statusMsg = response.statusText;

      yield put({
        type: "FETCH_WIDGET_ERROR",
        errorMsg: `Error - ${statusMsg}: Please try again later`,
      });
    }
  } catch (error) {
    console.log("Error while getting widgets -> " + error);
  }
}

function* fetchHash(payload) {
  try {
    yield put({
      type: "SET_LOADING_KNOWI",
      loading: true,
    });
    const response = yield axiosInstance.post(getKnowiHashEndPoint(), {
        contentfilters: payload.contentFilter,
    });
    console.log("response", response);
    if (response.status === 200) {
      const encryptedContent = response;
      yield put({
        type: "FETCH_KNOWI_HASH_SUCCESS",
        encryptedContent: encryptedContent,
      });
    } else if (response.status !== "OK") {
      const statusMsg = response.statusText;
      console.log("response statusMsg", statusMsg);
      yield put({
        type: "FETCH_KNOWI_HASH_ERROR",
        errorMsg: `Error - ${statusMsg}: Please try again later`,
      });
    } else if (response.status === 401) {
      localStorage.removeItem("ng2Idle.main.expiry");
    }
  } catch (error) {
    console.log("Error while getting widgets -> " + error);
  }
}

function* storeWidgetListToReducer(payload){
      const widgetList = payload.contentFilter?.widgets?.filter((m) => {
        return m.secureShareUrl.length > 0 && !m.name?.includes("lvl");
      }) ?? [];
  yield put({
        type: "FETCH_WIDGET_SUCCESS",
        widgets: widgetList,
      });
}

function* KnowiSaga() {
  yield takeLatest("FETCH_KNOWI_WIDGETS", fetchWidgetsData);
  yield takeLatest("FETCH_KNOWI_HASH", fetchHash);
  yield takeLatest("STORE_WIDGETS", storeWidgetListToReducer);
}

export default KnowiSaga;
